import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["overrideUrl"];
import React, { useContext } from 'react';
import { MediaType } from '../../../../../constants';
import { FlexibleUiContext } from '../../../../../state/flexible-ui-context';
import Media from '../media';
var Preview = function Preview(props) {
  var _ref = props !== null && props !== void 0 ? props : {},
    overrideUrl = _ref.overrideUrl,
    rest = _objectWithoutProperties(_ref, _excluded);
  var context = useContext(FlexibleUiContext);
  var data = overrideUrl ? {
    url: overrideUrl,
    type: MediaType.Image
  } : context === null || context === void 0 ? void 0 : context.preview;
  if (!data) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Media, _extends({}, rest, data));
};
export default Preview;